'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var requestAnimationFrame = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame : function () {};

/**
 * Handles debouncing of events via requestAnimationFrame
 * @see http://www.html5rocks.com/en/tutorials/speed/animations/
 * @param {Function} callback The callback to handle whichever event
 */

var Debouncer = function () {
  function Debouncer(callback) {
    _classCallCheck(this, Debouncer);

    this.callback = callback;
    this.ticking = false;
  }
  /**
   * dispatches the event to the supplied callback
   * @private
   */


  _createClass(Debouncer, [{
    key: 'update',
    value: function update() {
      this.callback && this.callback();
      this.ticking = false;
    }
    /**
     * ensures events don't get stacked
     * @private
     */

  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.ticking) {
        requestAnimationFrame(this.rafCallback || (this.rafCallback = this.update.bind(this)));
        this.ticking = true;
      }
    }
    /**
     * Attach this as the event listeners
     */

  }, {
    key: 'handleEvent',
    value: function handleEvent() {
      this.requestTick();
    }
  }]);

  return Debouncer;
}();

exports.default = Debouncer;


//////////////////
// WEBPACK FOOTER
// ./~/react-headrooms/lib/debouncer.js
// module id = 1218
// module chunks = 0 1